import { gql } from "@apollo/client";
export const AppFileUpload = gql `
  mutation AppFileUpload($upload: Upload!) {
    AppFileUpload(upload: $upload) {
      _id
      name
      path
      downloadUrl
      size
      createdAt
      updatedAt
    }
  }
`;
